import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import { withTheme } from '@material-ui/core/styles';

// import other components within the same project here

import Localization from "../Localization.jsx"

import RootPage from "../pages/RootPage.jsx"
import HeatmapBar from "../views/heatmap/HeatmapBar.jsx"
import HeatmapDetail from "../views/heatmap/HeatmapDetail.jsx"

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Icon,
  Card,
  CardContent,
  Grid,
  Divider,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';

const DATE_VIEW_BY_LOCALE = 0;
const SESSION_VIEW_BY_DATE = 1;
const HEATMAP_VIEW_BY_SESSION_ID = 2;


class HeatmapPage extends React.Component {
  static DATE_VIEW_BY_LOCALE() {
    return DATE_VIEW_BY_LOCALE;
  }

  static SESSION_VIEW_BY_DATE() {
    return SESSION_VIEW_BY_DATE;
  }

  static HEATMAP_VIEW_BY_SESSION_ID() {
    return HEATMAP_VIEW_BY_SESSION_ID;
  }

  constructor(props) {
    super(props);

    this.state = {
      status: DATE_VIEW_BY_LOCALE,
      currentLocaleId: this.props.localeData.id,
      currentDate: 0,
      currentSessionId: 0,
      currentHeatmapId: 0,
      dateList: [],
      sessionIDList: [],
      heatmapList: [],
      maxHeight: 0,
      selectedIndex: -1,
      selectedDisplayName: 'all',
      selectedSchoolName: 'all',
      uniqueDisplayNames: ['all'],
      uniqueSchoolNames: ['all']
    };
    autoBind(this);

    this.refresh();
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    if (this.refs.heatmapBar && this.refs.heatmapBar.refs.div) {
      const boundingRect = this.refs.heatmapBar.refs.div.getBoundingClientRect();
      const height = window.innerHeight - (boundingRect.y + window.scrollY + boundingRect.height);
      this.setState({
        maxHeight: height,
      });
    }
  }

  s2ab(s){
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }

  refresh() {
    switch(this.state.status) {
      case DATE_VIEW_BY_LOCALE:
        this.props.root.refs.API.request("get_session_date_group_by_locale_id", { locale_id: this.state.currentLocaleId}, this.getSessionDateGroupByLocaleIDOK, this.getSessionDateGroupByLocaleIDFailed);
        break;
      case SESSION_VIEW_BY_DATE:
        this.props.root.refs.API.request("get_sessions_by_date_group", { locale_id: this.state.currentLocaleId, date: this.state.currentDate }, this.getSessionIDByDateOK, this.getSessionIDByDateFailed);
        break;
      case HEATMAP_VIEW_BY_SESSION_ID:
        this.props.root.refs.API.request("get_heatmaps_by_session_id", { session_id: this.state.currentSessionId}, this.getHeatmapsBySessionIDOK, this.getHeatmapsBySessionIDFailed);
        break;
      default:
        break;
    }
  }

  getSessionDateGroupByLocaleIDOK(res){
    this.setState({dateList: res.body['result']});
    console.log("datelist");
    console.log(this.state.dateList);
  }

  getSessionDateGroupByLocaleIDFailed(err){
    console.log("getSessionDateGroupByLocaleIDFailed");
  }

  getSessionIDByDateOK(res) {
    const sessionList = res.body['result'];
    
    sessionList.forEach((session, index) => {
      this.props.root.refs.API.request(
        "get_heatmaps_by_session_id", 
        { session_id: session.id }, 
        (heatmapRes) => {
          const heatmaps = heatmapRes.body['result'];
          if (heatmaps && heatmaps.length > 0) {
            sessionList[index].display_name = heatmaps[0].display_name;
            sessionList[index].name = heatmaps[0].name;
            this.setState({sessionIDList: sessionList});
            this.updateUniqueValues(sessionList);
          }
        },
        (err) => console.log("Failed to fetch heatmaps for session", session.id)
      );
    });
    
    this.setState({sessionIDList: sessionList});
  }

  getSessionIDByDateFailed(err) {
    console.log("getSessionIDByDateFailed");
  }

  getHeatmapsBySessionIDOK(res) {
    this.setState({heatmapList: res.body['result']});
    console.log("heatmapList");
    console.log(this.state.heatmapList);
  }

  getHeatmapsBySessionIDFailed(err) {
    console.log("getHeatmapsBySessionIDFailed");
  }

  handleDisplayNameChange = (event) => {
    this.setState({ selectedDisplayName: event.target.value });
  };

  handleSchoolNameChange = (event) => {
    this.setState({ selectedSchoolName: event.target.value });
  };

  updateUniqueValues(sessionList) {
    const displayNames = ['all', ...new Set(sessionList.map(session => session.display_name).filter(Boolean))];
    const schoolNames = ['all', ...new Set(sessionList.map(session => session.name).filter(Boolean))];
    
    this.setState({
      uniqueDisplayNames: displayNames,
      uniqueSchoolNames: schoolNames
    });
  }

  filterSessions() {
    return this.state.sessionIDList.filter(session => {
      const displayNameMatch = this.state.selectedDisplayName === 'all' || session.display_name === this.state.selectedDisplayName;
      const schoolNameMatch = this.state.selectedSchoolName === 'all' || session.name === this.state.selectedSchoolName;
      return displayNameMatch && schoolNameMatch;
    });
  }

  handleDateClicked(date, changeHistory=true){
    console.log("date: " + date);
    this.setState({
      status: SESSION_VIEW_BY_DATE,
      currentDate: date,
      selectedIndex: -1,
    });
    this.state.status = SESSION_VIEW_BY_DATE;
    this.state.currentDate = date;
    this.state.selectedIndex = -1;
    this.refresh();

    if (changeHistory) {
      this.props.root.pushHistory("heatmap/date_group");
    }
  }

  handleSessionClicked(session_id, changeHistory=true) {
    console.log("session_id: " + session_id);
    this.setState({
      status: HEATMAP_VIEW_BY_SESSION_ID,
      currentSessionId: session_id,
      selectedIndex: -1,
    });
    this.state.status = HEATMAP_VIEW_BY_SESSION_ID;
    this.state.currentSessionId = session_id;
    this.state.selectedIndex = -1;
    this.refresh();

    if (changeHistory) {
      this.props.root.pushHistory("date_group/session_id");
    }
  }

  handleHeatmapClicked(index, heatmap_id) {
    this.setState({
      currentHeatmapId: heatmap_id,
      selectedIndex: index,
    });
    this.state.currentHeatmapId = heatmap_id;
    this.state.selectedIndex = index;
    this.refs.heatmapDetail.setState({ heatmapId: heatmap_id });
    this.refs.heatmapDetail.state.heatmapId = heatmap_id;
    this.refs.heatmapDetail.refresh();
  }

  handleBackButtonClicked() {
    if (this.state.status == SESSION_VIEW_BY_DATE) {
      this.setState({
        status: DATE_VIEW_BY_LOCALE,
      })
      this.state.status = DATE_VIEW_BY_LOCALE;
    }
    else if (this.state.status == HEATMAP_VIEW_BY_SESSION_ID) {
      this.setState({
        status: SESSION_VIEW_BY_DATE,
      })
      this.state.status = SESSION_VIEW_BY_DATE;
      this.refs.heatmapDetail.setState({ heatmapId: 0 });
    }
    else if (this.state.status == DATE_VIEW_BY_LOCALE) {
      this.props.root.changeStatus(this.props.root.STATUS_VIEW_LOCALE_LIST())
    }
  }

  handleForwardButtonClicked() {
    console.log("handleForwardButtonClicked");
    if (this.state.status == SESSION_VIEW_BY_DATE) {
      this.handleSessionClicked(this.state.currentSessionId, false);
    }
    else if (this.state.status == DATE_VIEW_BY_LOCALE) {

    }
  }

  render() {
    return (
      <div>
        <HeatmapBar root={this.props.root} parent={this} ref="heatmapBar"/>
        <Grid container>
          <Grid item xs={8} sm={3}>
            <Switch condition={this.state.status}>
              <Case value={DATE_VIEW_BY_LOCALE}>
                <List style={{
                  maxHeight: this.state.maxHeight, 
                  overflow: 'auto', 
                  padding: '0',
                  width: '100%'
                }}>
                  <ListItem>
                    <ListItemText>
                      <Typography variant="h6">{this.props.localeData['locale_name']}</Typography>
                    </ListItemText>
                  </ListItem>
                  <Divider variant="middle"/>
                  <If condition={this.state.dateList.length == 0}>
                    <Then>
                      <Card style={{margin: "10px"}}>
                        <CardContent>
                          {Localization.strings.EMPTY_SESSION_REMINDER}
                        </CardContent>
                      </Card>
                    </Then>
                    <Else>
                      {this.state.dateList.map((row, i) => {
                        return (
                          <ListItem 
                            button 
                            key={i} 
                            onClick={()=>this.handleDateClicked(row['day'])}
                            style={{
                              margin: '4px 8px',
                              borderRadius: '8px',
                              backgroundColor: '#f5f5f5',
                              width: 'auto'
                            }}
                          >
                            <ListItemIcon>
                              <Icon style={{color: this.props.theme.palette.primary.main}}>event</Icon>
                            </ListItemIcon>
                            <ListItemText
                              style={{width: '100%', overflow: 'hidden'}}
                              primary={
                                <Typography variant="subtitle1" style={{fontWeight: 500, whiteSpace: 'normal'}}>
                                  {row['day']}
                                </Typography>
                              }
                              secondary={
                                <Typography variant="body2" color="textSecondary" style={{whiteSpace: 'normal'}}>
                                  {row['count']} {row['count'] === 1 ? 'Session' : 'Sessions'}
                                </Typography>
                              }
                            />
                          </ListItem>
                        );
                      })}
                    </Else>
                  </If>
                </List>
              </Case>
              <Case value={SESSION_VIEW_BY_DATE}>
                <List style={{
                  maxHeight: this.state.maxHeight, 
                  overflow: 'auto', 
                  padding: '0',
                  width: '100%'
                }}>
                  <ListItem>
                    <ListItemText>
                      <Typography variant="h6">{this.props.localeData['locale_name']}</Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <Grid container spacing={2} style={{padding: '8px'}}>
                      <Grid item xs={6}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel>{Localization.strings.FILTER_DISPLAY_NAME}</InputLabel>
                          <Select
                            value={this.state.selectedDisplayName}
                            onChange={this.handleDisplayNameChange}
                            label={Localization.strings.FILTER_DISPLAY_NAME}
                          >
                            {this.state.uniqueDisplayNames.map(name => (
                              <MenuItem key={name} value={name}>
                                {name === 'all' ? Localization.strings.FILTER_ALL_DISPLAY_NAMES : name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel>{Localization.strings.FILTER_SCHOOL_NAME}</InputLabel>
                          <Select
                            value={this.state.selectedSchoolName}
                            onChange={this.handleSchoolNameChange}
                            label={Localization.strings.FILTER_SCHOOL_NAME}
                          >
                            {this.state.uniqueSchoolNames.map(name => (
                              <MenuItem key={name} value={name}>
                                {name === 'all' ? Localization.strings.FILTER_ALL_SCHOOL_NAMES : name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider variant="middle"/>
                  <If condition={this.filterSessions().length == 0}>
                    <Then>
                      <Card style={{margin: "10px"}}>
                        <CardContent>
                          {this.state.selectedDisplayName !== 'all' || this.state.selectedSchoolName !== 'all' ? 
                            Localization.strings.NO_MATCHING_SESSIONS : 
                            Localization.strings.EMPTY_SESSION_REMINDER}
                        </CardContent>
                      </Card>
                    </Then>
                    <Else>
                      {this.filterSessions().map((row, i) => {
                        return (
                          <ListItem 
                            button 
                            key={i} 
                            onClick={()=>this.handleSessionClicked(row['id'])}
                            style={{
                              margin: '4px 8px',
                              borderRadius: '8px',
                              backgroundColor: '#f5f5f5',
                              width: 'auto'
                            }}
                          >
                            <ListItemIcon>
                              <Icon style={{color: this.props.theme.palette.primary.main}}>folder_open</Icon>
                            </ListItemIcon>
                            <ListItemText
                              style={{width: '100%', overflow: 'hidden'}}
                              primary={
                                <Typography variant="subtitle1" style={{fontWeight: 500, whiteSpace: 'normal'}}>
                                  {"Session " + row['id']}
                                </Typography>
                              }
                              secondary={
                                <div style={{whiteSpace: 'normal'}}>
                                  <Typography variant="body2" color="textPrimary" noWrap={false}>
                                    {row['display_name'] || 'No Display Name'}
                                  </Typography>
                                  <Typography variant="body2" color="textSecondary" noWrap={false}>
                                    {row['name'] || 'N/A'}
                                  </Typography>
                                  <Typography variant="body2" color="textSecondary" noWrap={false}>
                                    {row['submission_time']}
                                  </Typography>
                                </div>
                              }
                            />
                          </ListItem>
                        );
                      })}
                    </Else>
                  </If>
                </List>
              </Case>
              <Case value={HEATMAP_VIEW_BY_SESSION_ID}>
                <List style={{
                  maxHeight: this.state.maxHeight, 
                  overflow: 'auto', 
                  padding: '0',
                  width: '100%'
                }}>
                  <ListItem>
                    <ListItemText>
                      <Typography variant="h6">Session ID: {this.state.currentSessionId}</Typography>
                    </ListItemText>
                  </ListItem>
                  <Divider variant="middle"/>
                  {this.state.heatmapList.map( (row, i) => {
                    const time_start = new Date(Number(row['time_start']));
                    const time_end = new Date(Number(row['time_end']));
                    var time_start_str = time_start.getFullYear() + "-" + String(time_start.getMonth() + 1).padStart(2, '0') + "-" + String(time_start.getDate()).padStart(2, '0') + " " + String(time_start.getHours()).padStart(2, '0') + ":" + String(time_start.getMinutes()).padStart(2, '0') + ":" + String(time_start.getSeconds()).padStart(2, '0');
                    var time_end_str = String(time_end.getHours()).padStart(2, '0') + ":" + String(time_end.getMinutes()).padStart(2, '0') + ":" + String(time_end.getSeconds()).padStart(2, '0');
                    return (
                      <ListItem
                        button
                        key={i}
                        onClick={()=>this.handleHeatmapClicked(i ,row['id'])}
                        selected={i == this.state.selectedIndex}
                        style={{
                          margin: '4px 8px',
                          borderRadius: '8px',
                          backgroundColor: i == this.state.selectedIndex ? '#e3f2fd' : '#f5f5f5',
                          width: 'auto'
                        }}
                      >
                        <ListItemIcon>
                          <Icon style={{color: this.props.theme.palette.primary.main}}>theaters</Icon>
                        </ListItemIcon>
                        <ListItemText
                          style={{width: '100%', overflow: 'hidden'}}
                          primary={
                            <Typography variant="subtitle1" style={{fontWeight: 500, whiteSpace: 'normal'}}>
                              {i+1 + ". " + row['stage_name']}
                            </Typography>
                          }
                          secondary={
                            <div style={{whiteSpace: 'normal'}}>
                              <Typography variant="body2" color="textPrimary" noWrap={false}>
                                {row['display_name'] || 'No Display Name'}
                              </Typography>
                              <Typography variant="body2" color="textSecondary" noWrap={false}>
                                {row['name'] || 'N/A'}
                              </Typography>
                              <Typography variant="body2" color="textSecondary" noWrap={false}>
                                {time_start_str + " - " + time_end_str}
                              </Typography>
                            </div>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </Case>
            </Switch>
          </Grid>
          <Grid item xs={8} sm={9}>
            <HeatmapDetail root={this.props.root} parent={this} ref="heatmapDetail"
              maxHeight={this.state.maxHeight}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withTheme(HeatmapPage);
